module.exports = {
  Individual: 'cái',
  AreYouWantToCopy: 'Vui lòng xác nhận có sao chép không?',
  Hint: 'Thông báo',
  Confirm: 'Xác nhận',
  Cancel: 'Hủy bỏ',
  BiDomainName: 'Tên miền BI',
  FillBiDomainName: 'Vui lòng nhập tên miền BI'
}
